import "./style.css";
import ReactDOM from "react-dom/client";
import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience";
import { useProgress, Html } from "@react-three/drei";

const root = ReactDOM.createRoot(document.querySelector("#root"));
function Loader() {
  const { active, progress, errors, item, loaded, total } = useProgress();
  return <Html center style={{backgroundColor: "red"}}>{progress} % loaded</Html>;
}

root.render(
  <Canvas
    camera={{
      fov: 45,
      near: 0.1,
      far: 200,
      position: [0, 0, 8],
    }}
  >
      <Experience />
  </Canvas>
);
